import "bootstrap/dist/css/bootstrap.min.css"
import './src/styles/main.scss'

import fetch from 'isomorphic-fetch';
import React from 'react'
import Layout from './src/components/Layout'
import { ApolloProvider } from '@apollo/client'
import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';
// import { getPIMServer } from "./src/services/auth";

require("bootstrap")
const pimUrl = process.env.GATSBY_PIMCORE_URL;

export const client = new ApolloClient({
	link: new HttpLink({
		uri: pimUrl + '/pimcore-graphql-webservices/mortgageAdvisors?apikey=1614e0fb65707decebed2a8c265adea4',
		fetch
		},
	),
	cache: new InMemoryCache(),
});

export const wrapRootElement = ({ element, props }) => {
    // Wrap the element.
    return (<ApolloProvider client={client}><Layout {...props}>{element}</Layout></ApolloProvider>)
};
